export default __webpack_public_path__ + "b897135c8ae4c3c388d93249a4e66da7.svg";